var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomaniaJoker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.7 41.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 14.2,
    cy: 761.846,
    r: 7.217,
    gradientTransform: "translate(0 -747.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadd84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#dadd84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#dadd84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadd84",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 6.9c4 0 7.2 3.2 7.2 7.2s-3.2 7.2-7.2 7.2S7 18.1 7 14.1s3.2-7.2 7.2-7.2z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.3,
    x2: 13.801,
    y2: 19.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.3c-2.1 4.8-6.1 8.8-13.3 10-2.9-8.4 7.5-10.6 13.3-10z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 4.585,
    y1: 6.823,
    x2: 13.919,
    y2: 6.823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 13.6C9.4 11.6 5.8 7.5 4.6.4c7.9-2.7 9.7 7.5 9.3 13.2z",
    fill: "url(#c)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 16.417,
    y1: 17.651,
    x2: 20.821,
    y2: 27.009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.3c4 1.7 7.3 5.4 8.3 11.7-7.1 2.4-8.7-6.6-8.3-11.7z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 14.445,
    y1: 9.883,
    x2: 25.239,
    y2: 9.883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 13.7c1.4-3.8 5.1-7.1 10.4-7.8 2.3 6.3-5.3 8.3-10.4 7.8z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.291,
    x2: 12.445,
    y2: 19.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M.7 24.3H.6c-2.7-7.9 6-10.3 11.9-10.1C7.1 15-.2 18.4.7 24.3z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 8.53,
    y1: 2.195,
    x2: 12.108,
    y2: 15.406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.6.6V.5C11.9-2 14 6.8 13.9 12.4 13.3 7.1 10.1-.1 4.6.6z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 15.848,
    y1: 14.79,
    x2: 18.875,
    y2: 23.735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.6 25.9v.1c-6.5 2.2-8.4-5.6-8.3-10.6.6 4.7 3.5 11.1 8.3 10.5z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 16.215,
    y1: 9.946,
    x2: 25.237,
    y2: 9.946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 13.8c5.5-1.2 8.6-4.1 8.6-7.8 2 5.5-3.8 7.7-8.6 7.8z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 4.887,
    y1: 26.146,
    x2: 13.281,
    y2: 15.274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.5c-2.2 6.2-8 9.5-13.9 9.9 2.8 3.4 7.5 4 10.6.9 2.7-2.6 3.2-7.1 3.3-10.8z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 1.81,
    y1: 7.396,
    x2: 13.601,
    y2: 7.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c902e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9d234"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14.2C7.7 11.9 4.4 6.1 4.6.5 1.1 3.2.7 9 4.5 11.8c2.4 1.8 6.1 2.2 9.1 2.4z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 16.705,
    y1: 13.879,
    x2: 24.824,
    y2: 23.512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 13.9c5.2 2 8.2 7.2 8.1 12.2 3.2-2.5 3.3-7.5 0-10.1-2.1-1.7-5.4-2-8.1-2.1z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 14.034,
    y1: 8.615,
    x2: 24.834,
    y2: 8.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#36ac2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c902e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5c1.6-4.9 6.3-7.6 10.8-7.8-2.3-2.7-7.1-2.9-9.2.3-1.3 2.1-1.6 5-1.6 7.5z",
    fill: "url(#m)",
    style: {
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 39c1.7-.1 3-.6 3.9-1.5 1-1.1 1.4-2.6 1.4-7.4V13.6h3.6v17.9c0 3.8-.6 6.3-2.4 8.1-1.6 1.6-4.2 2.2-6.1 2.2l-.4-2.8zm9.2-30.9c0 1.2-.8 2.2-2.3 2.2-1.3 0-2.2-1-2.2-2.2s.9-2.2 2.2-2.2 2.3 1 2.3 2.2zm23.3 15.2c0 7.3-5.1 10.4-9.8 10.4-5.3 0-9.4-3.9-9.4-10.1 0-6.5 4.3-10.4 9.7-10.4 5.6 0 9.5 4.1 9.5 10.1zm-15.6.2c0 4.3 2.4 7.6 5.9 7.6 3.4 0 6-3.2 6-7.6 0-3.3-1.7-7.5-5.9-7.5-4.2-.1-6 3.8-6 7.5zm23.6-.9c.6-.7 1.2-1.5 1.8-2.2l5.8-6.8H77l-7.6 8.1L78 33.3h-4.4l-6.7-9.4-1.8 2v7.4h-3.5V4.4h3.5v18.2zm17.5 1.5c.1 4.8 3.1 6.8 6.7 6.8 2.6 0 4.1-.4 5.4-1l.6 2.6c-1.3.6-3.5 1.3-6.6 1.3-6.1 0-9.7-4-9.7-9.9s3.5-10.6 9.2-10.6c6.5 0 8.1 5.6 8.1 9.2 0 .7 0 1.3-.1 1.7H82.6zm10.5-2.6c0-2.2-.9-5.8-5-5.8-3.7 0-5.2 3.3-5.5 5.8h10.5zm7.9-1.8c0-2.3 0-4.3-.2-6.1h3.1l.2 3.9h.1c.9-2.6 3.1-4.3 5.5-4.3.4 0 .7 0 1 .1v3.4c-.4-.1-.7-.1-1.2-.1-2.5 0-4.3 1.9-4.8 4.5-.1.5-.1 1.1-.1 1.7v10.5H101V19.7z",
    fill: "#f60025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomaniaJoker);
export default __webpack_public_path__ + "static/media/romania_joker.5b5c324ae1e20ec4f3c070e31eebe70a.svg";
export { ForwardRef as ReactComponent };